<template>
  <div class="app-container">
    <!--/ 用户信息 -->
    <el-card>
      <div slot="header">
        <span>用户信息</span><span style="float: right; padding: 3px 0;font-size:14px;"></span>
      </div>
      <el-descriptions>
        <el-descriptions-item label="头像">
          <img :src="afterSaleInfo.user_info.avatar" alt="" style="width:30px;height:30px;border-radius: 30px;">
        </el-descriptions-item>
        <el-descriptions-item label="昵称">{{ afterSaleInfo.user_info.nickname }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ afterSaleInfo.user_info.phone }}</el-descriptions-item>
      </el-descriptions>
    </el-card>
    <!-- 售后信息 -->
    <el-card>
      <div slot="header">
        <span>售后信息</span>
      </div>
      <ul class="info el-row">
        <li class="el-col el-col-12">
          <label class="info-label">售后状态:</label>
          <div class="info-content">{{ mapstatus(afterSaleInfo.status) }}</div>
        </li>
        <li class="el-col el-col-12"><label class="info-label">退款单号:</label><div class="info-content">{{ afterSaleInfo.refund_order_no }}</div></li>
        <li class="el-col el-col-12">
          <label class="info-label">支付方式:</label>
          <div class="info-content">
            <!-- <el-tag v-if="afterSaleInfo.pay_type == 1" type="success">微信支付</el-tag>
            <el-tag v-else-if="afterSaleInfo.pay_type == 2" type="warning">余额支付</el-tag>
            <el-tag v-else>套餐抵消</el-tag> -->
            <el-tag v-if="afterSaleInfo.money > 0" type="success">微信支付</el-tag>
            <el-tag v-if="afterSaleInfo.balance > 0" type="warning">余额支付</el-tag>
            <el-tag v-if="afterSaleInfo.combo > 0">套餐抵消</el-tag>
          </div>
        </li>
        <li class="el-col el-col-12"><label class="info-label">退款金额:</label><div class="info-content">{{ afterSaleInfo.money }}</div></li>
        <li class="el-col el-col-12"><label class="info-label">退款余额:</label><div class="info-content">{{ afterSaleInfo.balance }}</div></li>
        <li class="el-col el-col-12"><label class="info-label">退款课时:</label><div class="info-content">{{ afterSaleInfo.combo }}</div></li>
        <li class="el-col el-col-12"><label class="info-label">售后原因:</label><div class="info-content">{{ afterSaleInfo.apply_reason }}</div></li>
        <li><label class="info-label">申请时间:</label><div class="info-content">{{ afterSaleInfo.apply_time }}</div></li>
        <li v-if="afterSaleInfo.status==2"><label class="info-label">退款时间:</label><div class="info-content">{{ afterSaleInfo.refund_time }}</div></li>

        <li v-if="afterSaleInfo.status==3"><label class="info-label">拒绝时间:</label><div class="info-content">{{ afterSaleInfo.refuse_time }}</div></li>
        <li v-if="afterSaleInfo.status === 3"><label class="info-label">拒绝原因:</label><div class="info-content">{{ afterSaleInfo.fail_reason }}</div></li>
      </ul>
    </el-card>
    <!--/ 售后信息 -->
    <el-card>
      <div slot="header">
        <span>订单信息</span><span style="float: right; padding: 3px 0;font-size:14px;"></span>
      </div>
      <el-card v-for="(item,index) in afterSaleInfo.product">
        <el-descriptions :column="4">
          <el-descriptions-item label="订单类型">{{ typeArrayItem(item.type) }}</el-descriptions-item>
          <el-descriptions-item label="订单号">{{ item.out_trade_no }}</el-descriptions-item>
          <el-descriptions-item label="订单金额">{{ item.total_price }}</el-descriptions-item>
          <el-descriptions-item label="折扣金额">{{ item.discount_price }}</el-descriptions-item>
          <el-descriptions-item label="实付金额">{{ item.price }}</el-descriptions-item>
          <el-descriptions-item label="支付方式">
            <el-tag v-if="item.pay_type == 1" type="success">微信支付</el-tag>
            <el-tag v-else-if="item.pay_type == 2" type="warning">余额支付</el-tag>
            <el-tag v-else>套餐抵消</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="支付时间">{{ item.pay_time }}</el-descriptions-item>
          <el-descriptions-item v-if="item.type == 1 || item.type == 2 || item.type == 4" label="门店名称">{{ item.site_name }}</el-descriptions-item>
        </el-descriptions>
      </el-card>
    </el-card>

    <!-- <el-card>
      <div slot="header">
        <span>订单信息</span><span style="float: right; padding: 3px 0;font-size:14px;">订单号: {{ afterSaleInfo.out_trade_no }}</span>
      </div>
      <el-descriptions :column="4">
        <el-descriptions-item label="订单总价" label-style="font-size: 17px;font-weight: bold;" content-style="font-size: 17px;font-weight: bold;">￥{{ afterSaleInfo.total_price }}</el-descriptions-item>
        <el-descriptions-item v-if="afterSaleInfo.discount_price > 0" label="优惠券优惠" label-style="font-size: 17px;font-weight: bold;" content-style="font-size: 17px;font-weight: bold;">￥{{ afterSaleInfo.discount_price }}</el-descriptions-item>
        <el-descriptions-item label="实付款" label-style="font-size: 17px;font-weight: bold;" content-style="font-size: 17px;font-weight: bold;color:#DD2727">￥{{ afterSaleInfo.price }}</el-descriptions-item>
        <el-descriptions-item v-if="afterSaleInfo.status == 2" label="退款金额" label-style="font-size: 17px;font-weight: bold;" content-style="font-size: 17px;font-weight: bold;">￥{{ afterSaleInfo.refund_price }}</el-descriptions-item>
      </el-descriptions>
      <div class="order-item">
        <table>
          <thead>
            <tr>
              <th style="text-align: center;">购买类型</th>
              <th class="action-cell" style="text-align: center;">类型名称</th>
              <th style="text-align: center;">金额</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="noborder"> {{ typeArrayItem(afterSaleInfo.type) }}</td>
              <td class="noborder">
                {{ orderdetail.type_name }}

              </td>
              <td class="noborder">￥{{ orderdetail.price }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-card> -->

    <div style="padding: 15px; text-align: center;">
      <router-link :to="{path:'/order/refund'}" class="el-button el-button--primary el-button--medium">返回</router-link>
    </div>
    <!--/ 退款确认modal -->
  </div>
</template>

<script>
import api from '@/api/order/refund'
export default {
  name: 'AfterSaleDetail',
  data() {
    return {
      order: {
        orderstatus: 1
      },
      expressInfo: [],
      afterSaleInfo: {},
      dialogVisible: false,
      check: false,
      orderdetail: [],
      statusFilters: [
        { text: '已发起', value: 1 },
        { text: '已同意', value: 2 },
        { text: '已拒绝', value: 3 },
        { text: '已取消', value: 4 },
        { text: '退款中', value: 5 }
      ],
      typeArray: [
        { label: '场地', value: 1 },
        { label: '教练', value: 2 },
        { label: '会员卡', value: 3 },
        { label: '课程套餐', value: 4 },
        { label: '余额充值', value: 5 }
        // { label: "课程", value: 6 },
      ]
    }
  },
  created() {
    this.afterSaleInfo.id = this.$route.query.id
    if (this.afterSaleInfo.id) {
      this.loadAfterSaleInfo()
    }
  },
  methods: {
    mapstatus(value) {
      let result = ''
      this.statusFilters.forEach((res) => {
        if (res.value === value) {
          result = res.text
        }
      })
      return result
    },
    loadAfterSaleInfo() {
      api.Detail(this.afterSaleInfo.id).then(res => {
        this.afterSaleInfo = res.data
        this.orderdetail = res.data.product
      })
    },
    typeArrayItem(value) {
      // 使用find方法查找数组中的对象
      var labelArr = this.typeArray.find(item => item.value === value)
      if (labelArr) {
        return labelArr.label
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.order-item th{
  text-align: center;
}
.el-card{
  margin:20px;
}
.payInfo{
  width: 50%;
  float:right;
  padding: 40px;
  text-align: right;
}
// 订单列表页样式
.order-item{
    border-top:  1px solid #dfe6ec;
    border-left:  1px solid #dfe6ec;
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 12px;
    color: #3c3c3c;
    .noborder{  border-right-width: 0;}
    .goods-image{
      float: left;
    }
    .goods-info{
      margin-left: 90px;
      text-align: left;
      .goods-title{
        padding: 5px 0;
      }
    }
    .goods-spec{
      color: #9e9e9e;
      padding: 3px;
    }
    .el-link{ font-size: 12px;color: #3c3c3c;}
    table{
      width: 100%;
      border-spacing:0;
      thead{
        background-color: #dfe6ec;
      }
    }
    td{
      text-align: center;
      padding: 10px;
      border-bottom: 1px solid #dfe6ec;
      border-right: 1px solid #dfe6ec;
      }
    th{
      text-align: left;
      padding: 8px;
    }
  }
</style>
